const base = require("../product/base");
const $body = $("body");
const isLoyaltyEnabled = $("meta[name=isLoyaltyEnabled]").attr("content") === "true";
const { updateCartTotals, clearCouponError, appendToUrl, validateBasket, createErrorNotification, updateApproachingDiscounts, updateCartContent } = require("../components/cartHelper");
const { removeMissingProductsFromMiniCart } = require("coremh/components/cartHelper");
const $serverErrorField = $(".addtocart-loyalty-gift-error");
/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = "";
    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }
    if (lineItem != null) {
        $(".availability-" + lineItem.UUID).empty();
        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += `<p class="line-item-attributes">${message}</p>`;
                });
            }
            if (lineItem.availability.inStockDate) {
                messages += `<p class="line-item-attributes line-item-instock-date">${lineItem.availability.inStockDate}</p>`;
            }
        }
        $(".availability-" + lineItem.UUID).html(messages);
    }
}

/**
 * Append server error
 * @param {string} $message - server error message text
 */
function appendServerError(message) {
    clearServerErrors();
    $serverErrorField.append("<p class='mb-0'>" + message + "</p>");
}

/**
 * Clear server error message
 */
function clearServerErrors() {
    $serverErrorField.html("");
}

function handleLoyaltyOffers(data) {
    var loyaltyPromotionIds;

    try {
        if (data.appliedLoyaltyPromotionIDs) {
            loyaltyPromotionIds = JSON.parse(data.appliedLoyaltyPromotionIDs);
        }
    } catch (error) {
        loyaltyPromotionIds = [];
    }

    // Remove loyalty promotions
    const loyaltyOrderIds = data.isLoyaltyOrder.map(function(offer) {
        if (offer.custom) {
            return offer.custom.id;
        } else {
            return;
        }});
    const loyaltyOrder = data.isLoyaltyOrder;
    if (loyaltyOrder.length) {
        loyaltyOrder.forEach(() => {
            var filteredOffers = loyaltyPromotionIds.filter(id => !loyaltyOrderIds.includes(id));
            if (filteredOffers.length) {
                filteredOffers.forEach(filteredId => {
                    const $offerInput = $(`[id^="remove-${filteredId}"]`);
                    $offerInput.trigger("click");
                    appendServerError(data.appliedLoyaltyPromotionError);
                });
            }
        });
    } else {
        // all promotions are not applied, remove all
        if (loyaltyPromotionIds) {
            loyaltyPromotionIds.forEach(filteredId => {
                const $offerInput = $(`[id^="remove-${filteredId}"]`);
                $offerInput.trigger("click");
                appendServerError(data.appliedLoyaltyPromotionError);
            });
        }
    }
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $(".cart-delete-confirmation-btn");
    var $productToRemoveSpan = $(".product-to-remove");
    $deleteConfirmBtn.data("pid", productID);
    $deleteConfirmBtn.data("action", actionUrl);
    $deleteConfirmBtn.data("uuid", uuid);
    $productToRemoveSpan.empty().append(productName);
}
module.exports = function () {
    $body.on("click", ".remove-product", function (e) {
        e.preventDefault();
        var actionUrl = $(this).data("action");
        var productID = $(this).data("pid");
        var productName = $(this).data("name");
        var uuid = $(this).data("uuid");
        confirmDelete(actionUrl, productID, productName, uuid);
    });
    $body.on("afterRemoveFromCart", function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });
    $body.on("click", ".cart-delete-confirmation-btn", function (e) {
        e.preventDefault();
        var productID = $(this).data("pid");
        var url = $(this).data("action");
        var uuid = $(this).data("uuid");
        var $product = $(`.product-info[data-uuid=${uuid}]`);
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);
        $("body > .modal-backdrop").remove();
        $.spinner().start();
        $body.trigger("cart:beforeUpdate");
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                handleLoyaltyOffers(data);
                var showLoyaltyAccountInfo = data && data.showLoyaltyAccountInfo ? data.showLoyaltyAccountInfo === true : false;
                $(".account-popin .js-loyalty-account-info").toggleClass("d-none", !showLoyaltyAccountInfo);
                $(".header .user-logged-in").toggleClass("user-loyalty-p", showLoyaltyAccountInfo);

                if (data.basket.items.length === 0) {
                    updateCartContent(data.basket.resources.numberOfItems);
                    $(".cart-items-number").empty().append(data.basket.resources.numberOfItems);
                    $(".minicart-quantity").empty().append(data.basket.numItems);
                    $(".minicart-link").attr({
                        "data-minicart-items": data.basket.numItems
                    });
                    $(".minicart-popover").empty().removeClass("show");
                    $body.removeClass("modal-open");
                    $("html").removeClass("veiled js-no-scroll");
                    if ($(".cart-page").hasClass("cart-empty")) {
                        if (data.customerAuthenticatedAndLoyaltyMember && !data.hasDigitalSubscription) {
                            $(".js-cart-empty-loyalty").removeClass("d-none");
                        }
                        $(".cart-content").addClass("d-none");
                    } else {
                        $(".js-cart-empty-loyalty").addClass("d-none");
                        $(".cart-content").removeClass("d-none");
                    }
                    $body.trigger("cart:update", data);
                    $.spinner().stop();
                }
                var hasLineItems = data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0;
                if (hasLineItems) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $(".uuid-" + data.toBeDeletedUUIDs[i]).remove();
                    }
                }
                $(".uuid-" + uuid).remove();
                if (!data.basket.hasBonusProduct) {
                    $(".bonus-product").remove();
                }
                removeMissingProductsFromMiniCart(data.basket.items);
                if (data?.itemsHtml && $(".cart-page").length) {
                    var $productCardsWrapper = $(".cart-product-cards");
                    $productCardsWrapper.children().not(".loyalty-cart, .espot-banner-slot").remove();
                    $productCardsWrapper.append(data.itemsHtml);
                    if ($product.hasClass("js-loyalty-product")) {
                        $(".js-loyalty-premium-wrapper").removeClass("d-none");
                        if ($(".cart-page").hasClass("cart-empty")) {
                            $(".js-cart-empty-loyalty").removeClass("d-none");
                            $(".cart-content").addClass("d-none");
                        }
                        else {
                            $(".js-cart-empty-loyalty").addClass("d-none");
                            $(".cart-content").removeClass("d-none");
                        }
                    }
                }
                $(".coupons-and-promos").empty().append(data.basket.totals.discountsHtml);
                updateCartTotals(data.basket);
                updateApproachingDiscounts(data.basket.approachingDiscounts);
                $body.trigger("setShippingMethodSelection", data.basket);
                validateBasket(data.basket);
                if (isLoyaltyEnabled) {
                    $("body").trigger("updateLoyaltySection", [parseInt(data.basket.totals.subTotalAdjusted, 10), data.minPurchaseToGetGifts]);
                }
                if (data.clearCouponError) {
                    clearCouponError();
                }

                // update the quantity select class
                pdpQuantityUpdate($(".attribute.quantity"), data);

                $body.trigger("cart:update", data);
                $.spinner().stop();
            },

            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                    return;
                }
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        });
    });

    $body.on("change", ".quantity-form > .quantity", function () {
        var $this = $(this);
        var preSelectQty = $this.data("pre-select-qty");
        var quantity = $this.val();
        var productID = $this.data("pid");
        var url = $this.data("action");
        var uuid = $this.data("uuid");

        if (quantity === "more") {
            var input = $(this).parent().find(".quantity-input");

            if (input.length) {
                var inputValue = input.val();

                if (inputValue === "") {
                    return;
                } else {
                    quantity = inputValue;
                }
            } else {
                return;
            }
        }

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid,
            preSelectQty: preSelectQty,
        };
        if ($this.closest(".minicart-popover").length > 0) {
            urlParams.fromMinicart = 1;
        }
        url = appendToUrl(url, urlParams);
        $this.parents(".card").spinner().start();
        $body.trigger("cart:beforeUpdate");
        $.ajax({
            url: url,
            type: "get",
            context: this,
            dataType: "json",
            success: function (data) {
                if (data.hasBonusProduct && urlParams.fromMinicart) {
                    $body.trigger("minicart:refresh");
                    $(".minicart").trigger("count:update", { quantityTotal: data.numItems });
                    return;
                }
                handleLoyaltyOffers(data);

                removeMissingProductsFromMiniCart(data.items);
                $(`.quantity[data-uuid="${uuid}"]`).val(quantity);
                $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                if (isLoyaltyEnabled) {
                    $("body").trigger("updateLoyaltySection", [parseInt(data.totals.subTotalAdjusted, 10), data.minPurchaseToGetGifts]);
                }
                $this.data("pre-select-qty", quantity);
                $body.trigger("cart:update", data);
                $.spinner().stop();
                $(".minicart-head > span").empty().html(data.resources.numberOfItems);
                var lineItem = data.items.find(function (item) {
                    return item.UUID === uuid;
                });
                var availabilityInfo = lineItem.availabilityInfo;
                if (availabilityInfo && availabilityInfo.quotaEnabled) {

                    // update quantities for all dropdowns and messages
                    var generalMessage;
                    var dropDownMessage;
                    data.items.forEach(function (item) {
                        var availabilityInfo = item.availabilityInfo;
                        if (availabilityInfo) {
                            if (availabilityInfo.generalMessages && availabilityInfo.generalMessages.length) {
                                generalMessage = availabilityInfo.generalMessages[0];
                            }
                            dropDownMessage = availabilityInfo.messages && availabilityInfo.messages.length > 0
                                ? availabilityInfo.messages[0] : null;
                        }
                        base.populateQuantityDropdown(item);
                        $this.parents(".product-info").find(".js-product-error-" + item.UUID).empty();
                        if (dropDownMessage) {
                            $this.parents(".product-info").find(".js-product-error-" + item.UUID)
                                .html(`<div class="line-item-availability"><p class="line-item-attributes">${dropDownMessage}</p></div>`);
                        }
                    });
                    base.showCartGlobalError(generalMessage);
                }
                if ($this.parents(".product-info").hasClass("bonus-product-line-item") && $(".cart-page").length) {
                    location.reload();
                }
                if (data.hasBonusProduct && $(".cart-page").length) {
                    var $productCardsWrapper = $(".cart-product-cards");
                    $productCardsWrapper.children().not(".loyalty-cart, .espot-banner-slot").remove();
                    $productCardsWrapper.append(data.itemsHtml);
                }
                if (!data.hasBonusProduct && $(".bonus-product-line-item").length) {
                    $(".bonus-product-line-item").remove();
                }
                if (data.clearCouponError) {
                    clearCouponError();
                }
                data.items.forEach(function (item) {
                    $(".line-item-price-" + item.UUID + " > .price .price").empty().append(item.priceTotal.price);
                    if (item.priceTotal.nonAdjustedPrice) {
                        if ($(".line-item-price-" + item.UUID + " > .price > .strike-through").length > 0) {
                            $(".line-item-price-" + item.UUID + " > .price > .strike-through").empty().append(item.priceTotal.nonAdjustedPrice);
                        } else {
                            $(".line-item-price-" + item.UUID + " > .price").append("<div class='strike-through'>" + item.priceTotal.nonAdjustedPrice + "</div>");
                        }
                    } else {
                        $(".line-item-price-" + item.UUID + " > .price > .strike-through").empty();
                    }
                });

                // update the quantity dropdown classes
                pdpQuantityUpdate($(".attribute.quantity"), data);

                // restile the quantity select if is not decorated
                var $quantitySelect = $(".quantity.quantity-select");
                if ($quantitySelect.length && !$quantitySelect.hasClass("select2-hidden-accessible")) {
                    $quantitySelect.select2({minimumResultsForSearch: -1});
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $(document).find(".cart-error").empty();
                    if (err.responseJSON.errorMessage) {
                        createErrorNotification(err.responseJSON.errorMessage);
                    }
                    $this.val(parseInt(preSelectQty, 10)).trigger("change");
                    $.spinner().stop();
                }
                $(".checkout-btn").addClass("disabled");
            }
        });
    });
    $body.on("hidden.bs.modal", "#chooseBonusProductModal", function () {
        $("#chooseBonusProductModal").remove();
        $(".modal-backdrop").remove();
        $body.removeClass("modal-open");
        if ($(".cart-page").length) {
            $(".launched-modal .btn-outline-primary").trigger("focus");
            $(".launched-modal").removeClass("launched-modal");
        } else {
            $(".product-detail .add-to-cart").focus();
        }
    });
    base.selectAttribute();
    base.colorAttribute();
};

$(document).ajaxComplete(function() {
    if (!$(".product-info").hasClass("stock-less-than-qty")) {
        $(".product-card-footer select.quantity").each(function () {
            var $this = $(this);
            $this.select2({
                minimumResultsForSearch: -1,
                dropdownParent: $this.closest(".quantity-form")
            });
        });
    }
});

/**
* Updates the quantity selection options on the Product Detail Page (PDP) based on the provided data.
* @param {jQuery} $pdpQuantityWrapper - The jQuery object representing the quantity wrapper element on the PDP.
* @param {Object} data - The data object containing information used to update the quantity options.
*/
function pdpQuantityUpdate($pdpQuantityWrapper, data) {
    if ($pdpQuantityWrapper.length) {
        var $pdpQuantitySelect = $pdpQuantityWrapper.find(".quantity-select");
        var queryStringPid = data.queryString.match(/pid=(\d+)/)[1];

        // get all the options with the correct pid
        var hasValidOptions = $pdpQuantitySelect.find("option").toArray().some(function(option) {
            return $(option).data("url").indexOf(queryStringPid) !== -1;
        });

        // check and update the select
        if (hasValidOptions) {
            $pdpQuantityWrapper.find(".quantity-pdp").removeClass("quantity-pdp-disabled");
            $pdpQuantitySelect.removeAttr("disabled");
        }
    }
}
